// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "e3bba515bf8a0c29","460": "1829401bb39723d6","917": "9679d32213c51534","985": "f3a69642dcd1c489",}[chunkId] + ".chunk.js"
}